import { apartmentContext } from "@whitespace/gatsby-plugin-smorgasbord-fastapi";
// import UserContext from "@whitespace/gatsby-theme-smorgasbord/src/contexts/userContext";
import PropTypes from "prop-types";
import React, {
  useState,
  useContext,
  useMemo,
  useCallback,
  useEffect,
} from "react";

import AptusContext from "../contexts/aptusContext";

AptusProvider.propTypes = {
  children: PropTypes.node,
  apiPath: PropTypes.string.isRequired,
};

export default function AptusProvider({ children, apiPath }) {
  // const { user } = useContext(UserContext);
  const { selectedApartment } = useContext(apartmentContext);

  const [bookings, setBookings] = useState([]);
  const [calendar, setCalendar] = useState([]);
  const [groups, setGroups] = useState([]);
  const [groupsError, setGroupsError] = useState(null);
  const [bookedPass, setBookedPass] = useState();

  const nextBooking = useMemo(
    () => bookings.find((booking) => !booking.isExpired),
    [bookings],
  );

  const getCustomerBookings = useCallback(async ({ apartmentId }) => {
    try {
      const response = await window.fetch(
        `/api${apiPath}/apartments/${apartmentId}/bookings`,
      );
      if (!response.ok) {
        throw new Error(response.statusText);
      }
      const { data: bookings } = await response.json();
      setBookings(bookings);
    } catch (error) {
      console.error(error);
    }
  }, []);

  const getGroups = useCallback(async ({ apartmentId }) => {
    setGroupsError(false);
    try {
      const response = await window.fetch(
        `/api${apiPath}/apartments/${apartmentId}/groups`,
      );
      if (!response.ok) {
        setGroupsError(true);
        throw new Error(response.statusText);
      }
      const { data: groups } = await response.json();
      setGroups(groups);
    } catch (error) {
      console.error(error);
    }
  }, []);

  useEffect(() => {
    if (selectedApartment?.id) {
      getGroups({ apartmentId: selectedApartment?.id });
      getCustomerBookings({ apartmentId: selectedApartment?.id });
    }
  }, [selectedApartment?.id]);

  useEffect(async () => {
    if (!groups.length) return;

    if (!selectedApartment?.id) {
      return;
    }

    try {
      const groupParams = groups.map((group) => {
        return ["groups", group.id];
      });
      const params = new URLSearchParams(groupParams);
      const response = await window.fetch(
        `/api${apiPath}/apartments/${
          selectedApartment.id
        }/calendar?${params.toString()}`,
      );
      if (!response.ok) {
        throw new Error(response.statusText);
      }

      const { data } = await response.json();
      setCalendar(data.calendar);
    } catch (error) {
      console.error(error);
    }
  }, [groups.map((group) => group.id).join(","), selectedApartment?.id]);

  // @TODO
  const nextBookablePass = null;

  return (
    <AptusContext.Provider
      value={{
        apiPath,
        bookedPass,
        calendar,
        groups,
        groupsError,
        bookings,
        nextBooking,
        nextBookablePass,
        setBookings,
        setBookedPass,
        getCustomerBookings,
      }}
    >
      {children}
    </AptusContext.Provider>
  );
}
